import React, { useState, useEffect } from 'react';
import StockportContainer from './Components/StockportContainer';
import Products from './Components/Products/Products';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import whatsappIcon from './Images/whatsapp-img.svg';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import Lottie from 'lottie-react';
import animationData from './animations/animation.json';
import Layout from './Components/Layout/Layout';

function App() {
  const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 2000);

      return () => clearTimeout(timer);
    }, []);

  return (
    <>
    <BrowserRouter>
    {isLoading && (<div className="loader-wrapper">
          <div className="loader-animation">
            <Lottie animationData={animationData} loop={true} />
          </div>
        </div>
      )}
    <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<StockportContainer />} />
            <Route path="/products" element={<Products />} />
          </Route>
        </Routes>
    <a href="https://wa.me/+971557841533" target="_blank" rel="noopener noreferrer" className="fixed-whatsapp-icon">
      <img src={whatsappIcon} alt="WhatsApp" className='whatsapp-fixed-image'/>
    </a>
    </BrowserRouter>
    </>
  );
}


export default App;
